import { createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../lib/types";

interface MailState {
    sendEmailSettingsStatus: PromiseStatuses
    openEmailSettingsModal: boolean
    openSendEmailModal: boolean
    emailSettingsTab: number
    selectedTemplateId: string | undefined
    openTemplateId: string | undefined
}

const initialState: MailState = {
    openEmailSettingsModal: false,
    openSendEmailModal: false,
    emailSettingsTab: 0,
    sendEmailSettingsStatus: "idle",
    selectedTemplateId: undefined,
    openTemplateId: undefined,
}

const mailSlice = createSlice({
    name: "mails/slice",
    initialState: initialState,
    reducers: {
        setEmailSettingsModalOpen: (state, action) => {
            state.openEmailSettingsModal = action.payload
        },
        setSendEmailModalOpen: (state, action) => {
            state.openSendEmailModal = action.payload
        },
        setEmailsSettingsTab: (state, action) => {
            state.emailSettingsTab = action.payload
        },
        setSelectedTemplateId: (state, action) => {
            state.selectedTemplateId = action.payload
        },
        setOpenTemplateId: (state, action) => {
            state.openTemplateId = action.payload
        },
    },
})

export const {
    setEmailSettingsModalOpen,
    setEmailsSettingsTab,
    setSendEmailModalOpen,
    setOpenTemplateId,
    setSelectedTemplateId,
} = mailSlice.actions

export default mailSlice.reducer